import React, {Fragment, useCallback, useMemo, useState} from 'react';
import {translate} from 'react-i18next';
import {compose} from "redux";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {TABLE_COL_MIN_WIDTH_ID} from "../../../../../styles/constants";
import {Button, Col, Icon, Modal} from "antd";
import {BUTTON_DELETE, BUTTON_DETAIL} from "../../../../../styles/buttons";
import CreateModifyPluginModal from "./modals/CreateModifyPlugin";
import {CREATE_MODE, DELETE_MODE, getNewPluginConfig, MODIFY_MODE} from "./utils";
import {connect} from "react-redux";

const onPluginChange = (mode, onChange, plugins) => (plugin) => {
    const newPluginsObj = getNewPluginConfig(plugins, plugin, plugin.PluginUid, mode)
    onChange(newPluginsObj);
};

const getBooleanColumnInfo = (t, titleFieldName, field) => ({
    title: t(`data.plugins.${titleFieldName}.shortLabel`),
    dataIndex: field,
    width: 30,
    withValuesFilter: true,
    render: bool => bool
        ? <Icon type="check"/>
        : null,
    renderText: bool => bool
        ? t(`data.plugins.${titleFieldName}.stringValue.true`)
        : t(`data.plugins.${titleFieldName}.stringValue.false`)
});

const mapStateToProps = state => ({
    appLanguage: state.app.language,
});

const PluginsList = ({
     t,
     Plugins = [],
     onChange,
     appLanguage,
 }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});

    const onModalHide = useCallback(() => {
        setIsModalVisible(false);
        setModalInfo({})
    }, [setIsModalVisible, setModalInfo]);

    const translatedPlugins = useMemo(() => {
        if (!Plugins) {
            return []
        }
        return Plugins.map(plugin => ({...plugin, MenuName: plugin.MenuName ? plugin.MenuName[appLanguage] : "", PluginName: plugin.PluginName ? plugin.PluginName[appLanguage] : ""}))
    }, [Plugins])

    const onModalShow = useCallback((mode, pluginUid = "") => {
        const selectedPlugin = pluginUid ? Plugins.find(p => p.PluginUid === pluginUid) : {};
        setModalInfo({mode, action: onPluginChange(mode, onChange, Plugins), plugin: selectedPlugin});
        setIsModalVisible(true);
    }, [setIsModalVisible, setModalInfo, Plugins, onChange])

    return (
        <Fragment>
            <CreateModifyPluginModal isModalVisible={isModalVisible} modalInfo={modalInfo} onModalHide={onModalHide} Plugins={Plugins} />
            <InfiniteScrollTable
                data={translatedPlugins || []}
                getRowKey={({id}) => id}
                columns={[{
                    title: t('data.plugins.id.shortLabel'),
                    dataIndex: 'PluginUid',
                    minWidth: TABLE_COL_MIN_WIDTH_ID
                }, {
                    title: t('data.plugins.pluginName.shortLabel'),
                    dataIndex: 'PluginName',
                    minWidth: TABLE_COL_MIN_WIDTH_ID
                },
                getBooleanColumnInfo(t, "config", "TransformFileEnabled"),
                getBooleanColumnInfo(t, "process", "ProcessFileEnabled"),
                getBooleanColumnInfo(t, "report", "ReportEnabled"),
                getBooleanColumnInfo(t, "mainMenu", "MainMenuEnabled"),
                getBooleanColumnInfo(t, "mapping", "FileMappingEnabled"),
                getBooleanColumnInfo(t, "enabled", "Enabled"),
                ]}
                actions={[
                    {...BUTTON_DETAIL, title: t('commons.actions.detail.title'), onClick: (plugin) => onModalShow(MODIFY_MODE, plugin.PluginUid)},
                    {...BUTTON_DELETE, title: t('commons.actions.delete.title'), onClick: (plugin, deselect) =>  Modal.confirm({
                            title: t('components.pluginsList.modals.delete.title', {
                                pluginName: plugin.PluginName
                            }),
                            onOk() {
                                deselect();
                                onPluginChange(DELETE_MODE, onChange, Plugins)(plugin);
                            },
                            cancelText: t('commons.buttons.cancel.title')
                        })}
                ]}
                rightActions={<Col>
                    <Button type="primary" icon="plus" onClick={() => onModalShow(CREATE_MODE)}>
                        {t('commons.buttons.create.title')}
                    </Button>
                </Col>}
            />
        </Fragment>
    )
};

export default compose(
    translate(), connect(mapStateToProps)
)(PluginsList);
